import React from 'react'
import { LSPayEcomRefundOption, SalePayment } from './types'

// filepath: /Users/minh.lai/code/vend/webregister/assets/scripts/components/sale/payment-panel/PaymentModal/LsPayEcomRefund.tsx

type Props = {
  paymentOption: LSPayEcomRefundOption
  onSuccess?: (result: SalePayment) => void
  onClose: () => void
}

export const LsPayEcomRefund = ({
  paymentOption,
  onSuccess,
  onClose,
}: Props) => {
  // Placeholder for LsPay eCommerce refund implementation
  return <></>
}
